import { colors } from './constants';

export const calculateDuration = (admissionDate) => {
  if (!admissionDate) return 0;
  const start = new Date(admissionDate);
  const today = new Date();
  const diff = Math.floor((today - start) / (1000 * 60 * 60 * 24));
  return diff;
};

export const getBedStyle = (bed, isHovered, selectedBeds) => {
  const isSelected = selectedBeds.some(b => b.id === bed.id);
  const bedStatus = isSelected ? 'selected' : bed.status;
  
  const baseStyle = {
    width: '80px',
    height: '80px',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    border: '2px solid transparent',
    position: 'relative'
  };

  const statusStyles = {
    available: {
      background: 'rgba(33, 128, 141, 0.15)',
      borderColor: 'rgba(33, 128, 141, 0.25)',
      color: colors.teal700,
      ...(isHovered && {
        background: 'rgba(33, 128, 141, 0.25)',
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 12px rgba(33, 128, 141, 0.2)'
      })
    },
    occupied: {
      background: 'rgba(192, 21, 47, 0.15)',
      borderColor: 'rgba(192, 21, 47, 0.25)',
      color: colors.red500,
      cursor: 'pointer',
      ...(isHovered && {
        background: 'rgba(192, 21, 47, 0.25)',
        transform: 'translateY(-2px)'
      })
    },
    selected: {
      background: 'rgba(168, 75, 47, 0.15)',
      borderColor: colors.orange500,
      borderWidth: '2px',
      color: colors.orange500,
      boxShadow: '0 0 0 3px rgba(168, 75, 47, 0.2)'
    },
    maintenance: {
      background: 'rgba(167, 169, 169, 0.15)',
      borderColor: colors.gray300,
      color: colors.gray400,
      cursor: 'not-allowed',
      opacity: 0.6
    },
    reserved: {
      background: 'rgba(230, 129, 97, 0.15)',
      borderColor: 'rgba(230, 129, 97, 0.25)',
      color: colors.orange500,
      ...(isHovered && {
        background: 'rgba(230, 129, 97, 0.25)',
        transform: 'translateY(-2px)'
      })
    }
  };

  return { ...baseStyle, ...statusStyles[bedStatus] };
};

export const getBadgeStyle = (status) => {
  const base = {
    display: 'inline-block',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '11px',
    fontWeight: 500,
    textTransform: 'uppercase'
  };
  
  if (status === 'available') {
    return { ...base, background: 'rgba(33, 128, 141, 0.15)', color: colors.teal700, border: `1px solid rgba(33, 128, 141, 0.25)` };
  } else if (status === 'occupied') {
    return { ...base, background: 'rgba(192, 21, 47, 0.15)', color: colors.red500, border: `1px solid rgba(192, 21, 47, 0.25)` };
  } else if (status === 'reserved') {
    return { ...base, background: 'rgba(230, 129, 97, 0.15)', color: colors.orange500, border: `1px solid rgba(230, 129, 97, 0.25)` };
  } else if (status === 'maintenance') {
    return { ...base, background: 'rgba(167, 169, 169, 0.15)', color: colors.gray400, border: `1px solid rgba(167, 169, 169, 0.25)` };
  }
  return base;
};

export const getNotificationStyle = (type) => {
  const baseStyle = {
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    padding: '16px 24px',
    borderRadius: '8px',
    fontSize: '14px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    zIndex: 2000,
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    minWidth: '300px'
  };
  
  if (type === 'success') {
    return { ...baseStyle, background: colors.green500, color: colors.cream50 };
  } else if (type === 'error') {
    return { ...baseStyle, background: colors.red500, color: colors.cream50 };
  } else if (type === 'info') {
    return { ...baseStyle, background: colors.slate900, color: colors.cream100 };
  }
  return baseStyle;
};
